import { z } from 'zod';

export type RegistrationStatusQuery = z.output<typeof registrationStatusQuerySchema>;
export type RegistrationStatusQueryDTO = z.input<typeof registrationStatusQuerySchema>;

export const registrationStatusQuerySchema = z.object({
  email: z.email(),
});
